import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { getStoredUser } from './user-storage.util';

/**
 * `canMatch` gate for the `/internal` route subtree.
 *
 * Unlike {@link RoleGuard} (a `canActivate` guard that runs AFTER the lazy
 * chunk is fetched), `canMatch` runs BEFORE the route is matched — so returning
 * a redirect here stops the internal admin bundle from ever downloading for a
 * non-INTERNAL user (defense-in-depth on the lazy chunk, not just activation).
 *
 * Mirrors {@link RoleGuard}'s INTERNAL logic and redirect targets: unauthenticated
 * → /login, non-INTERNAL → /invitations. The finer `canManage` check stays on the
 * `manage`/`catalogs` children via {@link ManageGuard}.
 */
export const internalCanMatch: CanMatchFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const user = getStoredUser();

  if (!user || !user.id) {
    return router.createUrlTree(['/login']);
  }

  // A missing or empty role defaults to PROFESSIONAL_ASSOCIATE, same as RoleGuard.
  const userRole: string = user.role || 'PROFESSIONAL_ASSOCIATE';
  if (userRole === 'INTERNAL') {
    return true;
  }

  return router.createUrlTree(['/invitations']);
};
